export default "__VITE_ASSET__BbcAJWET__"